/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartnerEnrollment } from '../../models/partner-enrollment';

export interface PartnerEnrollmentControllerInitEnrollment$Params {
}

export function partnerEnrollmentControllerInitEnrollment(http: HttpClient, rootUrl: string, params?: PartnerEnrollmentControllerInitEnrollment$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerEnrollment>> {
  const rb = new RequestBuilder(rootUrl, partnerEnrollmentControllerInitEnrollment.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartnerEnrollment>;
    })
  );
}

partnerEnrollmentControllerInitEnrollment.PATH = '/api/partner-enrollment';
